import { PageLoading } from '@case-management/components';

import { lazyLoad } from '@/utils/loadable';

interface Route {
  path: string;
  component: JSX.Element;
  exact?: boolean;
  permission?: 'configuration' | 'view' | 'case';
}

function withLazyLoad<T extends Promise<any>>(importFunc: () => T) {
  return lazyLoad(importFunc, undefined, {
    fallback: <PageLoading isWrap={true} />,
  });
}

const AdminDashBoard = withLazyLoad(() => import('@/pages/admin-dashboard'));
const CaseField = withLazyLoad(() => import('@/pages/case-field'));
const CaseForm = withLazyLoad(() => import('@/pages/case-form'));
const Tag = withLazyLoad(() => import('@/pages/tag'));
const TimeBaseAutomation = withLazyLoad(() => import('@/pages/time-base-automation'));
const EventBaseAutomation = withLazyLoad(() => import('@/pages/event-base-automation'));
const ServiceLevelAgreement = withLazyLoad(() => import('@/pages/service-level-agreement'));
const WebFormConfig = withLazyLoad(() => import('@/pages/web-form-config'));
const CaseView = withLazyLoad(() => import('@/pages/case-view'));
const CaseProcess = withLazyLoad(() => import('@/pages/case-process'));
const CaseCreate = withLazyLoad(() => import('@/pages/case-create'));
const TabManager = withLazyLoad(() => import('@/pages/tab-manager'));

export enum RoutePathEnum {
  ADMIN_ROOT = '/admin',
  ADMIN_FIELDS = '/admin/fields',
  ADMIN_FORMS = '/admin/forms',
  ADMIN_TAGS = '/admin/tags',
  ADMIN_AUTOMATION = '/admin/automation',
  ADMIN_EBA = '/admin/eba',
  ADMIN_SLA = '/admin/sla',
  ADMIN_WEBFORMS = '/admin/webforms',
  VIEW_ROOT = '/view',
  CASE_ROOT = '/case',
  UNAUTHORIZED = '/403',
  NOT_FOUND = '/404',
}

export const routes: Route[] = [
  // Configurations
  {
    path: RoutePathEnum.ADMIN_ROOT,
    component: <AdminDashBoard />,
    exact: true,
    permission: 'configuration',
  },
  // Case Fields
  {
    path: RoutePathEnum.ADMIN_FIELDS,
    component: <CaseField />,
    exact: false,
    permission: 'configuration',
  },
  // Case Forms
  {
    path: RoutePathEnum.ADMIN_FORMS,
    component: <CaseForm />,
    exact: false,
    permission: 'configuration',
  },
  // Tags
  {
    path: RoutePathEnum.ADMIN_TAGS,
    component: <Tag />,
    exact: false,
    permission: 'configuration',
  },
  // Time-based Automations
  {
    path: RoutePathEnum.ADMIN_AUTOMATION,
    component: <TimeBaseAutomation />,
    exact: false,
    permission: 'configuration',
  },
  // Event-based Automations
  {
    path: RoutePathEnum.ADMIN_EBA,
    component: <EventBaseAutomation />,
    exact: false,
    permission: 'configuration',
  },
  // Service Level Agreement
  {
    path: RoutePathEnum.ADMIN_SLA,
    component: <ServiceLevelAgreement />,
    exact: false,
    permission: 'configuration',
  },
  // Webform Configuration
  {
    path: RoutePathEnum.ADMIN_WEBFORMS,
    component: <WebFormConfig />,
    exact: false,
    permission: 'configuration',
  },
  // Case View
  {
    path: RoutePathEnum.VIEW_ROOT,
    component: <CaseView />,
    exact: true,
    permission: 'view',
  },
  // Tab Manager
  {
    path: RoutePathEnum.CASE_ROOT,
    component: <TabManager />,
    exact: true,
    permission: 'view',
  },
  // Case Create
  {
    path: `${RoutePathEnum.CASE_ROOT}/add/:id`,
    component: <CaseCreate />,
    exact: true,
    permission: 'view',
  },
  // Case Process
  {
    path: `${RoutePathEnum.CASE_ROOT}/:number`,
    component: <CaseProcess />,
    exact: true,
    permission: 'case',
  },
];
